
  // JS code added by StarApps Studio to hide variant using metafields
(function () {
  const KEY = (typeof vsk_data === 'function') ? vsk_data().storefront_key : null;
  const SHOP = window.Shopify && Shopify.shop;
  const HANDLE = location.pathname.split('/products/')[1]?.split('?')[0];
  if (!KEY || !SHOP || !HANDLE) { console.warn('[hideVariant] missing key/shop/handle'); return; }

  const QUERY = `
    query getProduct($handle: String!) {
      productByHandle(handle: $handle) {
        options { name values }
        variants(first: 250) {
          edges { node {
            selectedOptions { name value }
            hide: metafield(namespace: "custom", key: "hide_variant") { value }
          } }
        }
      }
    }`;

  let OPTIONS = [];
  let HIDDEN_COMBOS = []; 
  const isHidden = v => v.hide && (v.hide.value === 'true' || v.hide.value === '1');
  function getSelected() {
    const sel = {};
    document.querySelectorAll('input[type="radio"]:checked').forEach(r => {
      const name = (r.name || '').replace(/-\d+\s*$/, '').trim(); // "SELECT SHADE-1" -> "SELECT SHADE"
      if (name) sel[name] = r.value;
    });
    return sel;
  }
  function valuesToHide() {
    const sel = getSelected();
    const set = new Set(); 
    OPTIONS.forEach(opt => {
      opt.values.forEach(val => {
        const cand = Object.assign({}, sel, { [opt.name]: val });
        const match = HIDDEN_COMBOS.some(hc =>
          Object.keys(hc).every(k => cand[k] !== undefined && cand[k] === hc[k])
        );
        if (match) set.add(opt.name + '::' + val);
      });
    });
    return set;
  }
  function applyHiding() {
    if (!OPTIONS.length) return;
    const hide = valuesToHide();
    document.querySelectorAll('.swatch-view-item[orig-value], .swatch-selector[orig-value]').forEach(el => {
      const val = el.getAttribute('orig-value');
      const group = el.closest('.swatch-single');
      const optName = group ? (group.querySelector('.swatch-option-name') || {}).textContent : null;
      const shouldHide = [...hide].some(k => {
        const [o, v] = k.split('::');
        return v === val && (!optName || o === optName);
      });
      el.style.display = shouldHide ? 'none' : '';
    });
  }
  async function loadData() {
    const res = await fetch(`https://${SHOP}/api/2024-04/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': KEY },
      body: JSON.stringify({ query: QUERY, variables: { handle: HANDLE } })
    });
    const json = await res.json();
    if (json.errors) { console.error('[hideVariant] GraphQL', json.errors); return; }
    const p = json.data.productByHandle;
    OPTIONS = p.options;
    HIDDEN_COMBOS = p.variants.edges.map(e => e.node).filter(isHidden).map(v => {
      const m = {}; v.selectedOptions.forEach(o => m[o.name] = o.value); return m;
    });
    console.log('[hideVariant]', HIDDEN_COMBOS);
    applyHiding();
  }
  const observer = new MutationObserver(() => applyHiding());
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked', 'class'] });

  loadData();
})();




